var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _g3, _path11, _path12, _path13, _g4, _g5, _g6, _path14, _path15, _g7, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g8, _g9, _path23, _path24, _path25, _g10, _path26, _path27, _path28, _path29, _path30, _g11, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 415,
    height: 762.367,
    viewBox: "0 0 415 762.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "manager",
    transform: "translate(1468.391 -285.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pose-1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_161449",
    "data-name": "Path 161449",
    d: "M-1262.385,622.839l-2.409,11.989-8.838-1.36-.623-5.392,1.662-2.434,3.531-1.48,3.088-.978Z",
    transform: "translate(-80.132 -139.407)",
    fill: "#6a707b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161450",
    "data-name": "Path 161450",
    d: "M-1258.959,586.711l4.672-23.257,2.337-23.315-1.4-15.385,21.961-24.27h33.019s9.345,12.057,10.9,16.338,4.36,12.054,8.1,15.7,29.748,43.3,30.527,55.99.089,18.184.089,18.184-11.147,16.308-21.114,20.633-13.226,5.774-13.226,5.774-10.762.655-11.074,0-10.59-7-12.771-9.854-22.117-11.735-24.142-13.958S-1258.959,586.711-1258.959,586.711Z",
    transform: "translate(-86.445 -88.904)",
    fill: "#f0ab7e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161451",
    "data-name": "Path 161451",
    d: "M-1148.753,606.7s.141-1.134.223-3.533c-14.11,23.844-41.431,8.668-41.431,8.668-13.706.476-41.274-16.974-45.011-22.842s-8.255-48.43-3.374-52.026,1.142-14.062,1.816-19.773,11.474-9.5,11.474-9.5-1.91-3.207-4.482-7.211h-1.852l-21.961,24.27,1.4,15.385-2.337,23.315-4.672,23.257s25.854,20.364,27.879,22.584,21.962,11.1,24.142,13.958,12.462,9.2,12.771,9.854,11.074,0,11.074,0,3.257-1.446,13.226-5.774S-1148.753,606.7-1148.753,606.7Z",
    transform: "translate(-86.445 -88.904)",
    fill: "#e49f71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161452",
    "data-name": "Path 161452",
    d: "M-903.44,732.979s.08-1.109,3.87.635,27.2,16.02,26.657,18.715-6.149,5.077-6.149,5.077-8.2-.953-9.657-2.167-8.1-2.486-9.448-5.13-4-6.978-4.051-7.191-.889-2.644-1.222-3.383S-903.44,732.979-903.44,732.979Z",
    transform: "translate(-233.127 -184.725)",
    fill: "#dfe3e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87703",
    "data-name": "Group 87703",
    transform: "translate(-1142.808 506.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161453",
    "data-name": "Path 161453",
    d: "M-891.458,721.444s.059-.837,2.926.481,20.566,12.114,20.155,14.153-4.649,3.836-4.649,3.836-6.2-.718-7.3-1.638-6.123-1.88-7.144-3.878-3.023-5.278-3.061-5.437-.674-2-.924-2.559A32.129,32.129,0,0,1-891.458,721.444Z",
    transform: "translate(904.721 -686.559)",
    fill: "#7b7d8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161454",
    "data-name": "Path 161454",
    d: "M-820.045,684.516c3.745-8.292,6.073-20.964,2.194-20.964s-13.54,21.139-13.54,21.139h0l-.482.025c2.911-11.967,3.081-20.119-.459-19.613-3.572.51-7.9,11.341-8.757,20.323-4.532.484-8.586,1.176-10.668,2.135-6.284,2.894-14.96-1.524-14.96-1.524,3.59-8.835-8.376-10.207-8.376-10.207,1.5,7.923-7.181,10.665-10.474,12.646s-2.093,4.569-1.345,9.748-4.038,5.484-4.038,5.484l-1.945,2.742,14.659,10.055s3.591-8.075,6.733-10.512,21.988-2.439,27.972-2.286,6.131-3.5,6.131-3.5C-824.533,698.225-820.553,685.639-820.045,684.516Z",
    transform: "translate(905.268 -662.772)",
    fill: "#e7b89a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161455",
    "data-name": "Path 161455",
    d: "M-841.642,662.228c-4.805.253-5.654,8.176-7.382,21.1-.9,1.744-1.71,3.212-2.733,3.683-6.284,2.894-14.96-1.524-14.96-1.524,1.67-4.111-.288-10.116-2.014-12.239-1.261-1.552-5.99-3.192-7.273-2.425-1.184.708.911,4.457.911,4.457,1.5,7.922-7.181,10.665-10.474,12.646s-2.093,4.569-1.345,9.748-4.038,5.484-4.038,5.484L-892.9,705.9l6.428,4.408a18.557,18.557,0,0,0,8.184-5.323c5.159-5.6,5.273-7.54,13.239-8.341s21.245,4.6,23.363-3.849a41.381,41.381,0,0,0,1.357-8.349c.395-2.956.432-4.649.492-5.671C-839.574,674.382-836.729,661.97-841.642,662.228Z",
    transform: "translate(905.268 -662.224)",
    fill: "#bf8973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161456",
    "data-name": "Path 161456",
    d: "M-795.479,695.795c3.419-1.291,9.549-4.3,12.154-10.468,3.678-8.715,5.6-21.493,5.683-21.774-3.653.161-10.344,14.029-13.54,21.139Z",
    transform: "translate(865.058 -662.772)",
    fill: "#bf8973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161457",
    "data-name": "Path 161457",
    d: "M-881.3,757.615a98.887,98.887,0,0,0,3.678-21.353s-18.607-2.879-23.081-14.634a101,101,0,0,1-13.263,21.035C-903.227,748-892.4,753.091-881.3,757.615Z",
    transform: "translate(913.964 -686.744)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161458",
    "data-name": "Path 161458",
    d: "M-905.977,746.578a218.341,218.341,0,0,1,5.632-24.112c-.123-.274-.249-.551-.356-.838a101,101,0,0,1-13.263,21.035Q-909.982,744.645-905.977,746.578Z",
    transform: "translate(913.964 -686.744)",
    fill: "#7b7d8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161459",
    "data-name": "Path 161459",
    d: "M-865.1,704.905c-2.8,1.486-7.74,4.343-7.181,8.8,0,0,4.376-6.512,9.649-6.855s14.249,1.028,17.165,2.97,8.078,2.513,12.679-8.569-5.276,8.254-10.448,8C-854.358,705.366-862.3,703.42-865.1,704.905Z",
    transform: "translate(896.778 -676.916)",
    fill: "#916c54"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87704",
    "data-name": "Group 87704",
    transform: "translate(-1229.396 522.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161460",
    "data-name": "Path 161460",
    d: "M-1061.413,688.928s15.575,1.269,23.986,14.908,29.594,40.607,34.266,43.462,10.28,10.151,10.28,10.151-21.494,33.629-22.428,33.629-20.248-37.119-20.872-38.071-10.28-36.165-11.215-36.481-14.017-11.421-14.017-11.421Z",
    transform: "translate(1061.413 -688.928)",
    fill: "#e2ebf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161461",
    "data-name": "Path 161461",
    d: "M-1003.161,747.3c-4.673-2.855-25.855-29.82-34.266-43.462s-23.986-14.908-23.986-14.908v5.089l8.75-.961s10.747,3.122,14.8,12.688,21.182,31.774,26.321,37.164,13.4,7.456,15.732,11.581c.285.5.57.616.851.436C-997.016,752.536-1000.267,749.066-1003.161,747.3Z",
    transform: "translate(1061.413 -688.928)",
    fill: "#fff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161462",
    "data-name": "Path 161462",
    d: "M-964.23,799.685s-4.7-.608-6.988,2.882-12.876,4.969-12.876,4.969.1,11.422,0,11.74,21.806-.845,22.117-1.271,5.608-9.41,5.608-9.833S-964.23,799.685-964.23,799.685Z",
    transform: "translate(-199.897 -212.385)",
    fill: "#abafb8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161463",
    "data-name": "Path 161463",
    d: "M-960.386,866.143s43.924-62.177,46.414-113.569c0,0-24.61-3.805-30.527-19.351,0,0-17.445,40.922-58.563,61.86Z",
    transform: "translate(-192.068 -184.969)",
    fill: "#f0ecf5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161464",
    "data-name": "Path 161464",
    d: "M-944.5,733.223s-17.445,40.922-58.563,61.86l42.676,71.059s3.75-5.308,9.118-14.1c-10.1-47.059.212-93.965,7.241-117.712C-944.19,733.965-944.355,733.6-944.5,733.223Z",
    transform: "translate(-192.068 -184.969)",
    fill: "#dfe3e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161465",
    "data-name": "Path 161465",
    d: "M-1316.416,648.777l71.179,51.313,17.729-12.639-.718-5.295,15.981-14.248c17.755,4.124,17.317,9.1,20.433,16.082s19.935,37.75,29.281,50.758,32.085,63.127,38.315,99.926-18.69,121.818-18.69,121.818c-157.624,51.392-232.385-6.878-232.385-6.878l5.919-131.436s-11.526,9.835-34.889-4.952,8.411-85.141,11.214-89.74,12.773-23.634,19.314-36.641,12.615-12.847,16.354-15.227,40.964-22.841,40.964-22.841",
    transform: "translate(-22.952 -150.113)",
    fill: "#e2ebf2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161466",
    "data-name": "Path 161466",
    d: "M-1095.625,1012.962c2.412-14.361,4.087-28.78,3.989-40.792-9.935,8.325-29.649,19.469-66.409,23.629-61.678,6.979-97.912-41.865-97.912-41.865s-8.312,19.341-40.708,22.2-25.234-25.378-25.234-25.378-14.885,28.662-14.341,28.987-.3,14.478,1.571,20.5,5.918,12.054,12.1,22.524,27.465,12.057,31.2,14.912,78.5,11.418,159.181-9.519C-1115.772,1023.894-1103.986,1018.639-1095.625,1012.962Z",
    transform: "translate(-54.54 -274.755)",
    fill: "#cbd9e3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161467",
    "data-name": "Path 161467",
    d: "M-1199.791,739.172s-56.694,7.191-78.5,21.784c0,0,24.92,107.221,18.067,139.9,0,0-4.984,6.821-26.012,1.11s-43.766-10.148-42.987-19.031,20.443-32.164,44.331-42.969l-55.162,17.407-1.495,33.177,52.977,31.562L-1192,913.86s-63.859-2.221-64.17-10.785-1.1-51.076-10.05-94.854l-9.576-46.156S-1253.889,748.478-1199.791,739.172Z",
    transform: "translate(-52.356 -187.425)",
    fill: "#95989e"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87705",
    "data-name": "Group 87705",
    transform: "translate(-1227.988 522.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161468",
    "data-name": "Path 161468",
    d: "M-1016.51,751.347c-9.346-13.007-26.167-43.778-29.281-50.758-2.656-5.948-2.378-8.439-13.224-11.6,1,.307,8.26,2.887,12.12,14.289,4.153,12.268,20.352,42.509,27.621,50.547,6.529,7.219,29.155,52.118,37.219,80.01C-991,800.164-1008.579,762.386-1016.51,751.347Z",
    transform: "translate(1059.015 -688.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161469",
    "data-name": "Path 161469",
    d: "M-924.2,951.091c.091.462.183.869.277,1.236C-924.01,951.918-924.109,951.5-924.2,951.091Z",
    transform: "translate(1003.369 -797.175)",
    fill: "#fff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161470",
    "data-name": "Path 161470",
    d: "M-1339.637,819.508s-29.044,3.516-59.034-22.367c-9,21.986-23.5,65.988-5.591,77.324a63.024,63.024,0,0,0,9.9,5.18c5.768-2.918,10.088-5.18,10.088-5.18S-1380.444,835.9-1339.637,819.508Z",
    transform: "translate(-22.952 -211.351)",
    fill: "#cbd9e3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161471",
    "data-name": "Path 161471",
    d: "M-1307.694,810.978s-21.5,6.346-47.349,12.056-45.17-2.221-50.777-13.958,11.526-58.37,25.544-69.79,14.018-35.846,15.886-45.046c1.562-7.685,14.829-15.846,19.161-18.328-6.007,3.35-10.915,6.12-12.152,6.907-3.739,2.38-9.812,2.221-16.354,15.227s-16.509,32.039-19.314,36.641-34.577,74.957-11.214,89.74,34.889,4.952,34.889,4.952l-.152,3.4C-1340.661,825.966-1307.694,810.978-1307.694,810.978Z",
    transform: "translate(-22.952 -161.313)",
    fill: "#abafb8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161472",
    "data-name": "Path 161472",
    d: "M-1396.93,762.318c5.7-13.554,14.3-31.094,17.526-34.724,4.457-5.019,11.422-20.246,14.538-28.176s12.148-12.056,12.148-12.056c16.509-5.815,20.558,31.19,20.558,31.19.579-16.384-6.633-28.691-13.1-36.362-2.791,1.574-4.837,2.751-5.572,3.219-3.739,2.38-9.812,2.221-16.354,15.227s-16.509,32.039-19.314,36.641C-1387.517,738.94-1392.318,749.2-1396.93,762.318Z",
    transform: "translate(-29.496 -163.905)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87707",
    "data-name": "Group 87707",
    transform: "translate(-1402.889 788.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87706",
    "data-name": "Group 87706",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161473",
    "data-name": "Path 161473",
    d: "M-1356.849,1143.159s5.815,143.812,61.471,227.56h34.889s51.5-53.295,56.487-137.888S-1356.849,1143.159-1356.849,1143.159Z",
    transform: "translate(1356.849 -1143.159)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161474",
    "data-name": "Path 161474",
    d: "M-1256.757,1530.665s-12.669,11.419-2.7,20.94c0,0,.832,5.5,1.455,5.5h18.067s1.246.846,2.492-5.287c0,0,6.438,1.14,8.307,5.327,0,0,43.4,9.981,61.264,0l-53.995-26.477Z",
    transform: "translate(1318.229 -1303.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161475",
    "data-name": "Path 161475",
    d: "M-1231.855,1410.87c6.231,3.172-6.647,29.187-6.647,29.187s.736-1.54,9.555-11,15.969-36.652,15.969-36.652-8.7-5.435-10.882-6.493-19-12.265-19-12.265-52.541,4.444-53.372,4.444c-.5,0-9.448,4.3-16.9,8.377,7.228,23.382,16.453,46.578,28.22,67.1,4.34-8.383,8.789-21.36,14.017-30.641C-1262.8,1408.545-1238.085,1407.7-1231.855,1410.87Z",
    transform: "translate(1338.806 -1238.294)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161476",
    "data-name": "Path 161476",
    d: "M-1211.082,1340.222c-1.235-.635-53.244-10.152-54.757-10.152s-28.715,1.693-29.546,1.9-14.538,6.98-15.161,6.98-8.929,5.077-8.929,5.077l-2.172,7.133c2.566,9.53,5.441,19.131,8.668,28.636,6.346,8.535,14.27,16.54,21.123,15.412,14.123-2.328,40.083-15.021,44.442-11.952s15.958,10.476,27.205,8.353c4.044-.759,9.448-5.107,14.72-10.389a233.693,233.693,0,0,0,9.586-29.585C-1202.471,1346.522-1210.374,1340.589-1211.082,1340.222Z",
    transform: "translate(1342.319 -1220.308)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161477",
    "data-name": "Path 161477",
    d: "M-1178.248,1547.766s26.946,9.677,26.168,10.307S-1190.241,1546.182-1178.248,1547.766Z",
    transform: "translate(1284.109 -1310.106)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161478",
    "data-name": "Path 161478",
    d: "M-1256.419,1535.713s-3.777,5.152-3.582,9.32,1.789,6.505,3.074,5.828-1.868-4.162-.895-7.137S-1253.109,1532.98-1256.419,1535.713Z",
    transform: "translate(1316.877 -1304.952)",
    fill: "#232323"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87709",
    "data-name": "Group 87709",
    transform: "translate(-1294.507 769.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87708",
    "data-name": "Group 87708",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161479",
    "data-name": "Path 161479",
    d: "M-1172.288,1109.994s5.815,143.813,61.47,227.563h34.89s51.5-53.294,56.487-137.89S-1172.288,1109.994-1172.288,1109.994Z",
    transform: "translate(1172.288 -1109.994)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161480",
    "data-name": "Path 161480",
    d: "M-1072.2,1497.5s-12.668,11.42-2.7,20.938c0,0,.83,5.5,1.454,5.5h18.067s1.247.848,2.493-5.284c0,0,6.438,1.136,8.307,5.325,0,0,43.4,9.982,61.263,0l-53.994-26.475Z",
    transform: "translate(1133.668 -1269.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161481",
    "data-name": "Path 161481",
    d: "M-1043.067,1393.827c6.23,3.172-6.646,29.187-6.646,29.187s.736-1.537,9.554-11,15.968-36.648,15.968-36.648-8.7-5.436-10.88-6.5-19-12.262-19-12.262-52.541,4.44-53.371,4.44c-.489,0-8.879,4.024-16.174,7.986,7.554,22.683,17.076,44.878,29.054,64.3,3.853-8.243,7.851-19.271,12.455-27.448C-1074.011,1391.5-1049.3,1390.656-1043.067,1393.827Z",
    transform: "translate(1152.199 -1211.785)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161482",
    "data-name": "Path 161482",
    d: "M-1022.638,1323.174c-1.234-.635-53.244-10.155-54.755-10.155s-28.717,1.694-29.549,1.9-14.538,6.979-15.159,6.979-8.93,5.074-8.93,5.074l-1.934,6.359c3.122,10.821,6.656,21.669,10.658,32.295,5.912,7.363,12.821,13.531,18.9,12.532,14.122-2.326,40.081-15.016,44.443-11.95s15.957,10.476,27.2,8.353a14.275,14.275,0,0,0,4.528-1.917,238.033,238.033,0,0,0,15.875-41.075C-1016.818,1327.385-1022.067,1323.469-1022.638,1323.174Z",
    transform: "translate(1156.057 -1193.794)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161483",
    "data-name": "Path 161483",
    d: "M-993.687,1514.6s26.945,9.675,26.166,10.312S-1005.681,1513.014-993.687,1514.6Z",
    transform: "translate(1099.548 -1276.941)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161484",
    "data-name": "Path 161484",
    d: "M-1071.859,1502.547s-3.777,5.154-3.582,9.318,1.789,6.5,3.075,5.833-1.87-4.167-.9-7.141S-1068.549,1499.812-1071.859,1502.547Z",
    transform: "translate(1132.316 -1271.786)",
    fill: "#232323"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87713",
    "data-name": "Group 87713",
    transform: "translate(-1468.391 691.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87710",
    "data-name": "Group 87710",
    transform: "translate(41.76 9.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161485",
    "data-name": "Path 161485",
    d: "M-1375.656,993.333s-22.092,73.6-21.616,128.169h14.048s6.364-99.655,20.07-126.6Z",
    transform: "translate(1397.28 -993.333)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161486",
    "data-name": "Path 161486",
    d: "M-1397.272,1121.5h2.48c3.868-21.522,11.616-48.55,18.769-71.219,3.183-22.722,7.453-44.729,12.869-55.38l-12.5-1.57S-1397.749,1066.937-1397.272,1121.5Z",
    transform: "translate(1397.28 -993.333)",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87711",
    "data-name": "Group 87711",
    transform: "translate(64.351 13.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161487",
    "data-name": "Path 161487",
    d: "M-1353.835,1000.463s-10.847,84.392-.508,143.808l15.32-2.624s-10.991-109.864-.893-141.81Z",
    transform: "translate(1358.811 -999.838)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161488",
    "data-name": "Path 161488",
    d: "M-1354.344,1144.272l2.7-.461c.346-24.193,3.932-55.117,7.654-81.172-.619-25.374.076-50.172,4.068-62.8l-13.918.625S-1364.683,1084.855-1354.344,1144.272Z",
    transform: "translate(1358.811 -999.838)",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87712",
    "data-name": "Group 87712",
    transform: "translate(0 1.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161489",
    "data-name": "Path 161489",
    d: "M-1403.561,980.966s-63.756,11.206-64.794,36.374,20.146,33.206,34.058,27.7,36.549-42.3,38.211-48.852Zm-26.115,40.5c-11.058,6.029-16.665,1.745-16.665,1.745s-1.714-1.112.778-6.028,41.794-26.7,41.794-26.7S-1418.616,1015.438-1429.676,1021.464Z",
    transform: "translate(1468.391 -980.966)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161490",
    "data-name": "Path 161490",
    d: "M-1468.355,1017.532c-.443,10.751,3.174,18.368,8.543,23.144l8.9.328,3.327-14.251.826-6.9s.1-.115.261-.284a15.991,15.991,0,0,1,.933-2.2c.544-1.074,2.846-2.952,6.111-5.234,8.013-8.224,21.462-21.311,34.444-30.709C-1414.472,983.273-1467.409,994.616-1468.355,1017.532Z",
    transform: "translate(1468.392 -981.158)",
    fill: "#e0e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161491",
    "data-name": "Path 161491",
    d: "M-1390.477,997.165s-46.934,20.307-45.687,29.188a35,35,0,0,0,6.853,15.651s-5.192-12.693-1.87-17.766S-1390.477,997.165-1390.477,997.165Z",
    transform: "translate(1455.099 -987.652)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161492",
    "data-name": "Path 161492",
    d: "M-1451.269,1037.084s-6.647-9.1-6.647-12.693c0-2.5,13.8-18.752,22.178-28.386-15.767,5.864-31.578,14.762-32.52,27.011C-1466.774,1037.8-1451.269,1037.084-1451.269,1037.084Z",
    transform: "translate(1468.336 -987.174)",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161493",
    "data-name": "Path 161493",
    d: "M-905.021,1342.887s2.087,7-8.218,7.659-1.044-17.041-1.044-17.041Z",
    transform: "translate(1241.258 -1124.501)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161494",
    "data-name": "Path 161494",
    d: "M-1372.38,981.77s22.843,23.683,27.827,71.48-8.722,153.115-4.152,156.08,65.623,19.034,76.215,16.707,13.292-3.142,19.313.228,24.507,3.828,45.273,0,17.239,7.534,41.743,2.7,40.912-15.409,48.8-24.079,20.349-12.475,24.5-8.671c0,0,4.153-93.9-2.076-125.623s-7.893-57.523-6.23-68.1,6.645-16.925-5.816-20.727c0,0,.1,18.4-34.785,25.061s-135.818,10.152-177.871-8.566S-1377.625,972.249-1372.38,981.77Z",
    transform: "translate(1429.16 -977.597)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161495",
    "data-name": "Path 161495",
    d: "M-1189.323,1361.822c5.118-.924,7.75-.681,12.1,1.754a10.453,10.453,0,0,0,1.126.533c8.009-26.613,24.418-53.845,24.418-53.845C-1164.211,1320.455-1181.3,1348.148-1189.323,1361.822Z",
    transform: "translate(1353.204 -1114.907)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161496",
    "data-name": "Path 161496",
    d: "M-1068.476,1294.521c7.592,1.727,11.037,6.247,28.151,2.874.352-.073.684-.153,1.034-.226,8.155-32.95,21.394-71.893,28.663-92.163,17.869-49.834,15.8-61.623,15.8-61.623s-15.574,46.316-33.954,72.647C-1038.222,1229.544-1057.7,1265.888-1068.476,1294.521Z",
    transform: "translate(1303.324 -1046.026)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161497",
    "data-name": "Path 161497",
    d: "M-1035.842,1275.546c-16.247,21.5-33.489,53.383-41.791,72.9a26.816,26.816,0,0,1,9.451,1.865C-1055.994,1311.532-1035.842,1275.546-1035.842,1275.546Z",
    transform: "translate(1307.103 -1100.577)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161498",
    "data-name": "Path 161498",
    d: "M-927.933,1206.188l-12.647,94.951c.657-.638,1.281-1.278,1.849-1.9A33.7,33.7,0,0,1-925.8,1290.5Z",
    transform: "translate(1250.534 -1071.949)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161499",
    "data-name": "Path 161499",
    d: "M-1326.823,1160.609c-.583,51.8-8.945,121.854-5.23,124.261,1.094.708,5.44,2.171,11.553,3.955C-1319.106,1261.856-1317.314,1200.507-1326.823,1160.609Z",
    transform: "translate(1412.508 -1053.136)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161500",
    "data-name": "Path 161500",
    d: "M-1257.369,1030.752s-32.292,9.727-54.1,5.6c0,0,3.427,33.945,17.756,42.828s47.349,10.07,47.349,10.07-46.726,13.4-65.105-8.8c0,0-2.145,36.162,14.348,62.81,0,0-22.086-32.353-29.276-78.671s-18.867-52.352-18.867-52.352S-1305.653,1033.391-1257.369,1030.752Z",
    transform: "translate(1417.569 -991.895)",
    fill: "#e0e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161501",
    "data-name": "Path 161501",
    d: "M-1350.484,992.622s29.074,27.916,90.96,30.033C-1259.524,1022.655-1350.484,1032.8-1350.484,992.622Z",
    transform: "translate(1419.724 -983.798)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161502",
    "data-name": "Path 161502",
    d: "M-1353.771,984.921s-11.526-5.922-10.384-1.161,13.915,24.072,17.237,35.616c0,0-4.542-16.636-10.7-27.476C-1360.572,986.69-1361.74,984.1-1353.771,984.921Z",
    transform: "translate(1425.4 -979.376)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161503",
    "data-name": "Path 161503",
    d: "M-1334.747,1017.224l36.239,62.585s31.982,16.072,56.486,11.5c0,0-40.079-2.034-52.956-17.05S-1334.747,1017.224-1334.747,1017.224Z",
    transform: "translate(1413.229 -993.953)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161504",
    "data-name": "Path 161504",
    d: "M-1284.322,1170.322s-33.709-36.26-33.093-92.524C-1317.415,1077.8-1308.228,1135.744-1284.322,1170.322Z",
    transform: "translate(1406.078 -1018.955)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161505",
    "data-name": "Path 161505",
    d: "M-1347.638,986.925s30.829,28.99,93.286,31.686c0,0-47.037-6.662-68.219-18.4S-1347.638,986.925-1347.638,986.925Z",
    transform: "translate(1418.55 -981.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161506",
    "data-name": "Path 161506",
    d: "M-1085.237,1014.956s58.551,3.8,80.148-7.2c13.711-6.983,18.492-16.975,17.893-22.776-.281-.092-.563-.185-.863-.274,0,0,.1,18.4-34.785,25.061-13.409,2.557-36.573,4.65-62.4,5.187Z",
    transform: "translate(1310.244 -980.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161507",
    "data-name": "Path 161507",
    d: "M-949.47,1024.677s-20.559,35.528-38,51.706Z",
    transform: "translate(1269.89 -997.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161508",
    "data-name": "Path 161508",
    d: "M-1021.467,1134.339s-25.233,40.286-39.561,51.39-16.811,24.426-16.811,24.426-4.061-12.052,18.056-33.624A484.437,484.437,0,0,0-1021.467,1134.339Z",
    transform: "translate(1307.309 -1042.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161509",
    "data-name": "Path 161509",
    d: "M-937.037,1033.321l-24.09,54.986S-942.021,1066.312-937.037,1033.321Z",
    transform: "translate(1259.015 -1000.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161510",
    "data-name": "Path 161510",
    d: "M-929.546,1158.109l3.074-77.11S-935.92,1117.509-929.546,1158.109Z",
    transform: "translate(1246.891 -1020.277)",
    fill: "#fff"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161511",
    "data-name": "Path 161511",
    d: "M-1247.079,552.773s2.545-15.7,10.333-18.082l2.648-19.351-18.967,13.164v19.829Z",
    transform: "translate(-88.878 -95.036)",
    fill: "#3c2517"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161512",
    "data-name": "Path 161512",
    d: "M-1126.035,657.327s12.771,5.289,23.778-4.23c0,0,1.247-1.427,1.974,0s2.023,14.434-5.557,18.452-16.666.16-20.871-4.916S-1130.083,655.741-1126.035,657.327Z",
    transform: "translate(-139.883 -151.634)",
    fill: "#3c2517"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87715",
    "data-name": "Group 87715",
    transform: "translate(-1428.049 285.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161513",
    "data-name": "Path 161513",
    d: "M-1251.82,396.6c-2.706-5.652-6.056-11.412-11.5-14.391-5.235-2.87-11.548-2.685-17.452-1.911a103.141,103.141,0,0,0-21.646,5.264,49.231,49.231,0,0,0-13.885,7.2,24.7,24.7,0,0,0-8.88,12.777c-2.122,8.039.991,16.561,5.13,23.74a31.422,31.422,0,0,0,7.459,9.314,53.6,53.6,0,0,0,5.833,3.644,67.44,67.44,0,0,1,18.111,15.638c.248.305,16.531-7.775,18.167-8.466q9.243-3.882,18.741-7.055c3.866-1.295,11.939-1.955,13.084-6.884.575-2.469-.617-5.184-1.34-7.471-1.025-3.266-2.078-6.53-3.185-9.77A197.724,197.724,0,0,0-1251.82,396.6Z",
    transform: "translate(1369.221 -324.185)",
    fill: "#b0b0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161514",
    "data-name": "Path 161514",
    d: "M-1203.422,491.3c2.022.123,3.761-1.879,3.863-3.942s-1.1-5.591-2.684-6.881a19.094,19.094,0,0,0-5.41-2.764c2.284-3.03,1.189-6.436-1.867-8.65s-7.049-2.5-10.8-2.374c-16.719.571-32.775,7.9-45.882,18.489-2.269,1.835-4.528,3.861-5.656,6.576s-.771,6.292,1.553,8.048a7.008,7.008,0,0,0,.82,8.837,10.143,10.143,0,0,0,8.947,2.381,20.667,20.667,0,0,0,8.568-4.211c2.572-1.944,4.93-4.168,7.556-6.038a46.725,46.725,0,0,1,18.824-7.458C-1218.908,492.083-1210.2,490.892-1203.422,491.3Z",
    transform: "translate(1347.182 -360.037)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161515",
    "data-name": "Path 161515",
    d: "M-1238.456,339.059c-.755,20.915,15.279,38.491,35.818,39.264s37.8-15.561,38.555-36.477-15.28-38.492-35.819-39.26S-1237.7,318.145-1238.456,339.059Z",
    transform: "translate(1333.152 -292.302)",
    fill: "#b0b0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161516",
    "data-name": "Path 161516",
    d: "M-1234.5,336.782c-.707,19.608,14.326,36.087,33.581,36.81s35.437-14.588,36.146-34.2-14.325-36.09-33.576-36.811S-1233.792,317.172-1234.5,336.782Z",
    transform: "translate(1331.518 -292.302)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161517",
    "data-name": "Path 161517",
    d: "M-1399.667,413.731c-.756,20.912,15.279,38.495,35.819,39.264s37.792-15.561,38.553-36.478-15.281-38.487-35.821-39.259S-1398.914,392.819-1399.667,413.731Z",
    transform: "translate(1399.693 -323.124)",
    fill: "#b0b0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161518",
    "data-name": "Path 161518",
    d: "M-1396.446,416.784c-.674,18.637,13.615,34.3,31.918,34.99s33.677-13.869,34.354-32.5-13.616-34.3-31.918-34.986S-1395.775,398.15-1396.446,416.784Z",
    transform: "translate(1398.362 -326.025)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161519",
    "data-name": "Path 161519",
    d: "M-1350.272,324.256c-.81,22.439,16.4,41.3,38.43,42.124s40.553-16.7,41.364-39.135-16.4-41.3-38.431-42.124S-1349.461,301.813-1350.272,324.256Z",
    transform: "translate(1379.305 -285.092)",
    fill: "#b0b0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161520",
    "data-name": "Path 161520",
    d: "M-1346.776,322.241c-.771,21.286,15.554,39.176,36.451,39.96s38.472-15.839,39.242-37.124-15.556-39.173-36.456-39.956S-1346.007,300.956-1346.776,322.241Z",
    transform: "translate(1377.862 -285.093)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161521",
    "data-name": "Path 161521",
    d: "M-1213.993,486.362a78.114,78.114,0,0,0-42.238,11.277,27.709,27.709,0,0,0-7.995,6.647,12.548,12.548,0,0,0-2.634,9.882c1.957-7.392,7.824-13.2,14.488-16.758s14.121-5.179,21.477-6.763c5.45-1.17,10.943-2.351,16.517-2.373,5.554-.023,9.983,1.692,14.955,3.679C-1202.312,487.327-1209.115,486.489-1213.993,486.362Z",
    transform: "translate(1344.95 -368.158)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161522",
    "data-name": "Path 161522",
    d: "M-1261.605,486.242c-3.881,3.193-7.648,7.45-7.509,12.525,5.558-7.983,14.058-13.492,23.12-16.754s18.719-4.427,28.316-5.025c1.532-.1,6.058-.332,6.2-2.54.17-2.559-3.781-2.563-5.33-2.66a63.75,63.75,0,0,0-16.217,1.071A64.6,64.6,0,0,0-1261.605,486.242Z",
    transform: "translate(1345.797 -362.101)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161523",
    "data-name": "Path 161523",
    d: "M-1330.363,325.288c-16.368-5.135-6.989-24.5,3.2-30.6,14.5-8.672,36.075-8.318,47.651,5.614,2.758,3.322,4.992,7.571,4.625,12.022-.3,3.632-2.283,6.858-4.594,9.507-3.587,4.113-8.531,7.365-13.741,6.895-5.487-.5-9.878-4.873-14.311-8.405s-10.353-6.46-15.283-3.789a3.736,3.736,0,0,0-2.21,3.1,3.192,3.192,0,0,0,2.342,2.8,12.447,12.447,0,0,0,3.709.245,16.658,16.658,0,0,1,11.908,5.32c-3.478-2.008-7.6-2.138-11.538-2S-1326.574,326.475-1330.363,325.288Z",
    transform: "translate(1374.742 -286.652)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161524",
    "data-name": "Path 161524",
    d: "M-1155.862,322.928c-5.738-7.843-14.176-12.314-22.741-14.2a18.576,18.576,0,0,0-8.607-.262,10.246,10.246,0,0,0-6.88,5.746c-2.1,4.8-.187,11.034,3.3,14.477s8.149,4.648,12.643,5.215,9.1.62,13.421,2.217a15.387,15.387,0,0,1,9.8,10.289,17.84,17.84,0,0,0-13.971-6.919c1.324,0,4.357,3.331,5.527,4.229,1.836,1.4,3.641,2.949,5.538,4.233,2.627,1.78,5.571,2.185,7.472-1.2C-1146.59,340.036-1152.138,328.015-1155.862,322.928Z",
    transform: "translate(1315.189 -294.575)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161525",
    "data-name": "Path 161525",
    d: "M-1356.125,402.249c-3.7,1.4-5.979,5.341-6.62,9.305s.062,8,.671,11.965,1.11,8.076.089,11.95c-1.9,7.207-10,12.35-16.984,10.1-4.555-1.469-7.911-5.5-10.073-9.84a34.742,34.742,0,0,1-1.312-27.509c2.661-6.932,8.683-15.14,15.9-17.628,3.681-1.261,6.05.271,8.456,3.071C-1363.03,397.1-1360.2,400.131-1356.125,402.249Z",
    transform: "translate(1396.757 -328.452)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87714",
    "data-name": "Group 87714",
    transform: "translate(71.48 78.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161526",
    "data-name": "Path 161526",
    d: "M-1265.081,453.871q4.734,5.777,9.479,11.558c.06.07.118.144.174.213a45.374,45.374,0,0,0-7.385,6.226q-2.951-4.171-5.9-8.346A35.621,35.621,0,0,0-1265.081,453.871Z",
    transform: "translate(1274.151 -433.325)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161527",
    "data-name": "Path 161527",
    d: "M-1228.063,444.382q-5.387-10.611-10.778-21.225c-.3-.6-.611-1.193-.929-1.783a36.376,36.376,0,0,0,5.935-2.492,106.726,106.726,0,0,1,12.949,24.392A44,44,0,0,0-1228.063,444.382Z",
    transform: "translate(1262.204 -418.883)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161528",
    "data-name": "Path 161528",
    d: "M-1256.518,425.685a213.348,213.348,0,0,1,12.661,23.462,46.907,46.907,0,0,0-6.608,3.209q-5.709-8.9-11.427-17.794a33.385,33.385,0,0,0-1.153-8.788A35.276,35.276,0,0,0-1256.518,425.685Z",
    transform: "translate(1271.811 -421.691)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161529",
    "data-name": "Path 161529",
    d: "M-1211.022,431.29a23.238,23.238,0,0,0,5.629,1.492q3.361,8.121,6.723,16.25a36.8,36.8,0,0,0-4.747-.635A41,41,0,0,0-1211.022,431.29Z",
    transform: "translate(1250.338 -424.004)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161530",
    "data-name": "Path 161530",
    d: "M-1269.795,485.51c-.177.234-.353.459-.525.694a20.272,20.272,0,0,0-7.652-5.51,31.377,31.377,0,0,0,2.448-2.781Q-1272.659,481.709-1269.795,485.51Z",
    transform: "translate(1277.972 -443.248)",
    fill: "#cfd4d7"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161531",
    "data-name": "Path 161531",
    d: "M-1250.438,570.654s-5.14-13.325-12.3-8.725-9.345,20.938,7.321,29.027Z",
    transform: "translate(-82.661 -113.868)",
    fill: "#e49f71"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161532",
    "data-name": "Path 161532",
    d: "M-1164.242,695.956l20.805,21.537-40.794-11.968Z",
    transform: "translate(-117.289 -169.587)",
    fill: "#f0ecf5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161533",
    "data-name": "Path 161533",
    d: "M-1148.152,630.1s24.7,5.073,42.994-1.27c0,0,.383,12.942-11.7,13.851C-1123.5,643.178-1140.032,637.077-1148.152,630.1Z",
    transform: "translate(-139.203 -141.879)",
    fill: "#ae2824"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161534",
    "data-name": "Path 161534",
    d: "M-1132.575,638.356q12.319.233,24.637-.337a16.644,16.644,0,0,0,2.78-9.193c-18.3,6.343-42.993,1.27-42.993,1.27a56.345,56.345,0,0,0,14.063,8.222C-1133.585,638.331-1133.08,638.347-1132.575,638.356Z",
    transform: "translate(-139.203 -141.879)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87716",
    "data-name": "Group 87716",
    transform: "translate(-1317.277 465.589)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161535",
    "data-name": "Path 161535",
    d: "M-1121.856,608.045c2.65-2.1,2.352-8.692,2.352-8.692l-1.765,1.2c1.177-3.6-3.532-8.095-3.532-8.095.879,3-.886,6.9-.886,6.9l-2.059-1.8c-.587,5.1-4.12,2.7-4.12,2.7-5.3-3.3-13.837-5.4-13.837-5.4-4.694-1.793-7.7,1.708-9.186,4.259a10.028,10.028,0,0,0-5.241-1.859s-3.823-1.2-11.185,3c0,0-17.076,8.692-23.55,7.194,0,0-9.424.9-5.6-5.1a7.785,7.785,0,0,0-7.95,4.2s-1.474,3.6.587,5.693c0,0-2.354-.3-3.236-1.8,0,0-.294,7.2,4.711,8.7,0,0-2.062.9-3.536,0,0,0,2.655,7.5,10.307,8.7,0,0,2.059,3.9,9.42,3.6,0,0,10.009,2.1,19.431-8.99,0,0,6.774-7.5,11.776-10.2a13.549,13.549,0,0,0,5.437-5.292,9.57,9.57,0,0,0,3.393,2.3c3.536.9,10.3,3.6,10.3,3.6,7.067,6.593,12.952,4.793,12.952,4.793,7.363-1.2,8.54-10.19,8.54-10.19C-1119.207,608.945-1121.856,608.045-1121.856,608.045Z",
    transform: "translate(1211.063 -592.455)",
    fill: "#3c2517"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161536",
    "data-name": "Path 161536",
    d: "M-1121.856,608.33c2.65-2.1,2.352-8.692,2.352-8.692l-1.765,1.2c.967-2.952-2.026-6.505-3.134-7.688,3.068,6.757-.4,9.786-.4,9.786a14.836,14.836,0,0,1-1.18,4.5,7.172,7.172,0,0,0,2.65-1.5,51.963,51.963,0,0,1-1.47,5.4c-2.651,6.9-11.777.6-11.777.6-5-5.1-15.908-8.678-15.908-8.678a14.112,14.112,0,0,1-2.935,2.085c-5,2.7-11.773,10.192-11.773,10.192-9.423,11.1-19.431,9-19.431,9-7.363.3-9.419-3.6-9.419-3.6-7.655-1.2-10.306-8.7-10.306-8.7,1.471.9,3.533,0,3.533,0-3.392-1.017-4.347-4.645-4.612-6.885a8.75,8.75,0,0,0-.982,1.49s-1.474,3.6.587,5.693c0,0-2.354-.3-3.236-1.8,0,0-.294,7.2,4.711,8.7,0,0-2.062.9-3.536,0,0,0,2.655,7.5,10.307,8.7,0,0,2.059,3.9,9.42,3.6,0,0,10.009,2.1,19.431-8.99,0,0,6.774-7.5,11.776-10.2a14.277,14.277,0,0,0,3.479-2.629l0,0c.048-.054.1-.112.153-.163l.229-.254c.133-.146.262-.3.386-.458.047-.06.1-.119.146-.183.173-.22.339-.447.5-.688,0-.008.006-.015.013-.016a10.11,10.11,0,0,0,.532-.9,9.569,9.569,0,0,0,3.393,2.3c3.536.9,10.3,3.6,10.3,3.6,7.067,6.593,12.952,4.793,12.952,4.793,7.363-1.2,8.54-10.19,8.54-10.19C-1119.207,609.23-1121.856,608.33-1121.856,608.33Z",
    transform: "translate(1211.063 -592.741)",
    fill: "#c9c9c8",
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161537",
    "data-name": "Path 161537",
    d: "M-1156.081,525.875s-2.648,18.081,10.748,15.86,18.223-9.516,30.527-5.551,4.05,30.93-7.164,37.117-26,7.615-26.785-4.6,13.078-4.6,14.324-3.488l1.941-1.032s-3.5-6.107-3.809-6.424-10.279-4.283-10.9-4.839-10.747-3.568-11.682-5.313-1.011-14.831-1.011-14.831Z",
    transform: "translate(-127.334 -99.385)",
    fill: "#f0ab7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161538",
    "data-name": "Path 161538",
    d: "M-1112.315,536.445c-12.3-3.965-17.132,3.332-30.527,5.551-12.264,2.034-11.079-12.944-10.795-15.489h0s-2.134,14.643,6.745,16.23,17.365-5.77,23.985-6.5,14.122,1.111,15.783,7.35-2.231,22.153-11.784,28.974c0,0-12.317,7.614-22.176,3.964,0,0-4.718-2.207-4.641-8.988,0,0-.662-9.833,13.784-2.06-1.246-1.111-15.107-8.726-14.324,3.488s15.571,10.787,26.785,4.6S-1100.011,540.412-1112.315,536.445Z",
    transform: "translate(-129.824 -99.646)",
    fill: "#e49f71",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161539",
    "data-name": "Path 161539",
    d: "M-1126.283,715l16.03-13.922,5.43,10.2Z",
    transform: "translate(-141.208 -171.703)",
    fill: "#f0ecf5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87725",
    "data-name": "Group 87725",
    transform: "translate(-1282.247 586.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87718",
    "data-name": "Group 87718",
    transform: "translate(12.266 66.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161540",
    "data-name": "Path 161540",
    d: "M-1112.013,922.189a9.342,9.342,0,0,1-9.256,9.425,9.341,9.341,0,0,1-9.255-9.425,9.342,9.342,0,0,1,9.255-9.425A9.343,9.343,0,0,1-1112.013,922.189Z",
    transform: "translate(1130.524 -912.764)",
    fill: "#abafb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161541",
    "data-name": "Path 161541",
    d: "M-1112.213,922.673a8.66,8.66,0,0,1-8.582,8.738,8.66,8.66,0,0,1-8.58-8.738,8.66,8.66,0,0,1,8.58-8.736A8.661,8.661,0,0,1-1112.213,922.673Z",
    transform: "translate(1130.05 -913.248)",
    fill: "#cbd9e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87717",
    "data-name": "Group 87717",
    transform: "translate(5.795 6.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161542",
    "data-name": "Path 161542",
    d: "M-1118.652,924.274a1.012,1.012,0,0,1-1,1.022,1.013,1.013,0,0,1-1-1.022,1.01,1.01,0,0,1,1-1.019A1.009,1.009,0,0,1-1118.652,924.274Z",
    transform: "translate(1120.656 -923.255)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161543",
    "data-name": "Path 161543",
    d: "M-1110.279,924.274a1.012,1.012,0,0,1-1,1.022,1.013,1.013,0,0,1-1-1.022,1.01,1.01,0,0,1,1-1.019A1.009,1.009,0,0,1-1110.279,924.274Z",
    transform: "translate(1117.2 -923.255)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161544",
    "data-name": "Path 161544",
    d: "M-1118.652,931.925a1.013,1.013,0,0,1-1,1.022,1.014,1.014,0,0,1-1-1.022,1.011,1.011,0,0,1,1-1.02A1.01,1.01,0,0,1-1118.652,931.925Z",
    transform: "translate(1120.656 -926.413)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161545",
    "data-name": "Path 161545",
    d: "M-1110.279,931.925a1.013,1.013,0,0,1-1,1.022,1.014,1.014,0,0,1-1-1.022,1.012,1.012,0,0,1,1-1.02A1.01,1.01,0,0,1-1110.279,931.925Z",
    transform: "translate(1117.2 -926.413)",
    fill: "#8f919b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87720",
    "data-name": "Group 87720",
    transform: "translate(81.658 52.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161546",
    "data-name": "Path 161546",
    d: "M-996.5,896.047a8.008,8.008,0,0,1-7.933,8.079,8.007,8.007,0,0,1-7.931-8.079,8,8,0,0,1,7.931-8.076A8.006,8.006,0,0,1-996.5,896.047Z",
    transform: "translate(1012.359 -887.971)",
    fill: "#abafb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161547",
    "data-name": "Path 161547",
    d: "M-996.67,896.461a7.421,7.421,0,0,1-7.353,7.489,7.423,7.423,0,0,1-7.354-7.489,7.42,7.42,0,0,1,7.354-7.488A7.419,7.419,0,0,1-996.67,896.461Z",
    transform: "translate(1011.954 -888.385)",
    fill: "#cbd9e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87719",
    "data-name": "Group 87719",
    transform: "translate(4.965 5.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161548",
    "data-name": "Path 161548",
    d: "M-1002.187,897.828a.867.867,0,0,1-.859.876.867.867,0,0,1-.859-.876.869.869,0,0,1,.859-.874A.87.87,0,0,1-1002.187,897.828Z",
    transform: "translate(1003.905 -896.954)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161549",
    "data-name": "Path 161549",
    d: "M-995.01,897.828a.865.865,0,0,1-.858.876.867.867,0,0,1-.858-.876.869.869,0,0,1,.858-.874A.868.868,0,0,1-995.01,897.828Z",
    transform: "translate(1000.942 -896.954)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161550",
    "data-name": "Path 161550",
    d: "M-1002.187,904.389a.867.867,0,0,1-.859.874.867.867,0,0,1-.859-.874.866.866,0,0,1,.859-.874A.867.867,0,0,1-1002.187,904.389Z",
    transform: "translate(1003.905 -899.662)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161551",
    "data-name": "Path 161551",
    d: "M-995.01,904.389a.866.866,0,0,1-.858.874.867.867,0,0,1-.858-.874.866.866,0,0,1,.858-.874A.865.865,0,0,1-995.01,904.389Z",
    transform: "translate(1000.942 -899.662)",
    fill: "#8f919b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87722",
    "data-name": "Group 87722",
    transform: "translate(63.899 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161552",
    "data-name": "Path 161552",
    d: "M-1026.738,807.083a8.006,8.006,0,0,1-7.931,8.078,8.006,8.006,0,0,1-7.932-8.078,8.006,8.006,0,0,1,7.932-8.078A8.006,8.006,0,0,1-1026.738,807.083Z",
    transform: "translate(1042.601 -799.005)",
    fill: "#abafb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161553",
    "data-name": "Path 161553",
    d: "M-1026.908,807.5a7.425,7.425,0,0,1-7.354,7.492,7.426,7.426,0,0,1-7.354-7.492,7.423,7.423,0,0,1,7.354-7.489A7.422,7.422,0,0,1-1026.908,807.5Z",
    transform: "translate(1042.194 -799.419)",
    fill: "#cbd9e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87721",
    "data-name": "Group 87721",
    transform: "translate(4.966 5.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161554",
    "data-name": "Path 161554",
    d: "M-1032.427,808.868a.867.867,0,0,1-.859.874.865.865,0,0,1-.859-.874.867.867,0,0,1,.859-.874A.868.868,0,0,1-1032.427,808.868Z",
    transform: "translate(1034.145 -807.994)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161555",
    "data-name": "Path 161555",
    d: "M-1025.249,808.868a.866.866,0,0,1-.859.874.865.865,0,0,1-.857-.874.867.867,0,0,1,.857-.874A.868.868,0,0,1-1025.249,808.868Z",
    transform: "translate(1031.182 -807.994)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161556",
    "data-name": "Path 161556",
    d: "M-1032.427,815.428a.868.868,0,0,1-.859.874.866.866,0,0,1-.859-.874.867.867,0,0,1,.859-.874A.868.868,0,0,1-1032.427,815.428Z",
    transform: "translate(1034.145 -810.702)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161557",
    "data-name": "Path 161557",
    d: "M-1025.249,815.428a.867.867,0,0,1-.859.874.866.866,0,0,1-.857-.874.867.867,0,0,1,.857-.874A.868.868,0,0,1-1025.249,815.428Z",
    transform: "translate(1031.182 -810.702)",
    fill: "#8f919b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87724",
    "data-name": "Group 87724",
    transform: "translate(0 15.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161558",
    "data-name": "Path 161558",
    d: "M-1132.9,834.024a9.342,9.342,0,0,1-9.256,9.425,9.341,9.341,0,0,1-9.255-9.425,9.341,9.341,0,0,1,9.255-9.425A9.342,9.342,0,0,1-1132.9,834.024Z",
    transform: "translate(1151.412 -824.599)",
    fill: "#abafb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161559",
    "data-name": "Path 161559",
    d: "M-1133.1,834.506a8.662,8.662,0,0,1-8.582,8.739,8.661,8.661,0,0,1-8.581-8.739,8.662,8.662,0,0,1,8.581-8.739A8.663,8.663,0,0,1-1133.1,834.506Z",
    transform: "translate(1150.938 -825.081)",
    fill: "#cbd9e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87723",
    "data-name": "Group 87723",
    transform: "translate(5.793 6.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161560",
    "data-name": "Path 161560",
    d: "M-1139.542,836.107a1.015,1.015,0,0,1-1,1.02,1.016,1.016,0,0,1-1-1.02,1.013,1.013,0,0,1,1-1.022A1.013,1.013,0,0,1-1139.542,836.107Z",
    transform: "translate(1141.548 -835.085)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161561",
    "data-name": "Path 161561",
    d: "M-1131.165,836.107a1.015,1.015,0,0,1-1,1.02,1.013,1.013,0,0,1-1-1.02,1.01,1.01,0,0,1,1-1.022A1.012,1.012,0,0,1-1131.165,836.107Z",
    transform: "translate(1138.089 -835.085)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161562",
    "data-name": "Path 161562",
    d: "M-1139.542,843.759a1.013,1.013,0,0,1-1,1.022,1.014,1.014,0,0,1-1-1.022,1.012,1.012,0,0,1,1-1.021A1.012,1.012,0,0,1-1139.542,843.759Z",
    transform: "translate(1141.548 -838.244)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161563",
    "data-name": "Path 161563",
    d: "M-1131.165,843.759a1.013,1.013,0,0,1-1,1.022,1.011,1.011,0,0,1-1-1.022,1.01,1.01,0,0,1,1-1.021A1.011,1.011,0,0,1-1131.165,843.759Z",
    transform: "translate(1138.089 -838.244)",
    fill: "#8f919b"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87726",
    "data-name": "Group 87726",
    transform: "translate(-1308.404 419.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161564",
    "data-name": "Path 161564",
    d: "M-1194.5,520.583l-1.455,7.508,13.188-9.358.571-3.914Z",
    transform: "translate(1195.953 -514.708)",
    fill: "#3c2517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161565",
    "data-name": "Path 161565",
    d: "M-1154.581,514.631v3.647s11.32-.583,13.914,1.375c0,0-.1-3.276-2.8-4.175S-1154.581,514.631-1154.581,514.631Z",
    transform: "translate(1178.877 -514.63)",
    fill: "#3c2517"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161566",
    "data-name": "Path 161566",
    d: "M-1172.888,542.4s.157,5.34-2.231,6.662-11.838,2.008-11.838,2.008,10.124,1.323,13.446-1.058S-1172.888,542.4-1172.888,542.4Z",
    transform: "translate(-19.886 195.364) rotate(14)",
    fill: "#1b100e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161567",
    "data-name": "Path 161567",
    d: "M-1148.89,535.794s-.116,3.908,1.632,4.875,8.664,1.472,8.664,1.472-7.408.967-9.84-.775S-1148.89,535.794-1148.89,535.794Z",
    transform: "translate(-295.97 -364.253) rotate(-14)",
    fill: "#1b100e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161568",
    "data-name": "Path 161568",
    d: "M-1188.055,548.154s.571-9.3,5.555-10.944,8.827,2.311,8.827,2.311S-1185.719,530.124-1188.055,548.154Z",
    transform: "translate(-115.711 -103.899)",
    fill: "#e49f71"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161569",
    "data-name": "Path 161569",
    d: "M-1261.983,572.607s10.245,2.371,8.94,5.025-5.867,7.206-.93,8.06,1.489,2.843-1.956,0,1.769-8.06,1.769-8.06S-1257.885,573.27-1261.983,572.607Z",
    transform: "translate(-85.197 -118.674)",
    fill: "#e49f71",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87730",
    "data-name": "Group 87730",
    transform: "translate(-1305.439 523.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161570",
    "data-name": "Path 161570",
    d: "M-1128.954,701.055c.722-.877,1.647,2.408,1.608,3.846s-9.492,8.918-10.192,9.833c-6.32,8.227-14.922,10.448-23.09,10.838-9.523.463-19.458-1.35-27.527-9.355a8.189,8.189,0,0,1-2.747-5.344c-.137-2.367,4.648-3.782,5.686-2.06-1.584-2.522-1.886-8.6-1.339-12.053.9-5.667,2.547-6.081,4.47-4.253,8.563,8.13,21.087,20.364,29.527,20.555,3.956.092,6.933-5.474,10.761-7.268,1.012-.473,7.062-8.995,8.141-8.652C-1132.08,697.642-1127.434,699.611-1128.954,701.055Z",
    transform: "translate(1190.905 -691.539)",
    fill: "#ae2824"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87729",
    "data-name": "Group 87729",
    transform: "translate(43.328 20.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87728",
    "data-name": "Group 87728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87727",
    "data-name": "Group 87727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161571",
    "data-name": "Path 161571",
    d: "M-1115.307,733.192c1.31-3.311,3.628-5.566,6.073-5.945s5.007,1.144,6.692,3.995c1.823,3.082,2.644,7.508,4.71,10.2,1.9,2.481,4.74,2.991,6.947,1.246a6.04,6.04,0,0,0,2.194-4.109,4.846,4.846,0,0,0-.913-3.438,8.313,8.313,0,0,1,2.976,5.845,17.055,17.055,0,0,1-1.529,8.868,18.04,18.04,0,0,1-4.579,5.931c-4.2,3.66-9.189,5.392-13.854,3.69s-8.884-7.162-10.224-14.447A20.756,20.756,0,0,1-1115.307,733.192Z",
    transform: "translate(1117.124 -727.191)",
    fill: "#ae2824"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_161572",
    "data-name": "Path 161572",
    d: "M-1097.785,736.659c.755,1.939,1.17,4.2,2.1,5.946,1.4,2.636,3.809,3.592,5.929,2.82s3.928-3.066,5.178-5.873c1.167,4.2-.2,9.172-2.189,12.5-2.724,4.553-6.664,7.215-10.619,7.183s-7.888-2.77-10.579-7.368a2.933,2.933,0,0,0,3.011.274c-1.207-.884-2.023-2.957-1.988-5.053a8.113,8.113,0,0,0-.07-2.136c-.465-1.773-2.483-1.682-2.666-3.571,1.446.62,3.085-1.067,3.479-3.316.386-2.179-.966-4.949.386-6.655C-1103.437,728.381-1098.991,733.559-1097.785,736.659Z",
    transform: "translate(1157.379 -707.618)",
    fill: "#d13627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161573",
    "data-name": "Path 161573",
    d: "M-1134.26,745.279c4.277,4.319,5.445,15.243,4.244,23.035-1.217,7.786-5.774,13.969-10.817,14.658s-10.2-4.172-12.228-11.521c1.732,2.849,5.485,2.593,6.946-.625,1.368-3.019.564-7.269-.627-10.47s-2.76-6.333-2.853-10.046c-.125-5.044,2.853-9.418,6.022-9.859S-1136.938,742.574-1134.26,745.279Z",
    transform: "translate(1175.285 -711.708)",
    fill: "#ae2824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161574",
    "data-name": "Path 161574",
    d: "M-1136.779,742.111c-2.069-1.061-6.1-1.661-7.788,1.036-2.04,3.26-2.587,8.866-1.277,12.933.837,2.614,2.316,4.692,2.873,7.487a12.755,12.755,0,0,1-1.314,8.54c-1.336,2.23-3.339,3.336-5.276,3.147,3.081,4.434,7.636,6.517,11.579,4.421s6.891-8.783,6.224-15.294a11.289,11.289,0,0,1-1.741,6.146c1.8-4.37-1.792-10.829.065-15.152a20.363,20.363,0,0,1,1.519-2.448C-1129.4,748.61-1134.564,743.26-1136.779,742.111Z",
    transform: "translate(1173.839 -712.043)",
    fill: "#d13627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161575",
    "data-name": "Path 161575",
    d: "M-1139.937,752.482c.469-2.971,2-5.46,3.866-6.276-1.887-1.384-4.271-.824-5.823,1.368a12.375,12.375,0,0,0-1.522,9.012c.652,3.11,2.381,5.4,3.124,8.47a14.184,14.184,0,0,1-.731,8.728c-1.141,2.471-3.1,3.935-5.026,3.768,2.517,1.711,5.736.233,7.289-3.337-.8,2.754-2.413,4.882-4.269,5.6a9.269,9.269,0,0,0,5.141-2,10.722,10.722,0,0,0,3.478-6.108,25,25,0,0,0-.03-7.91,41.694,41.694,0,0,1-.517-7.922c.157-2.1,2.679-6.707.58-7.776C-1135.79,747.385-1139.559,750.127-1139.937,752.482Z",
    transform: "translate(1172.39 -713.792)",
    fill: "#ee4823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161576",
    "data-name": "Path 161576",
    d: "M-1094.358,740.416c1.027,2.311,1.549,5.128,2.678,7.311,1.411,2.728,3.744,4.176,5.949,3.695,2.2-.5,4.2-2.91,5.081-6.153-.308,3.619-1.875,6.912-3.991,8.366a6.783,6.783,0,0,0,3.7-3.189c-1.79,3.5-4.3,6.179-7.091,7.061s-5.853-.117-8.038-3.014a17.252,17.252,0,0,1-2.743-12.121c.244-1.715-.039-4.869,1.156-5.186C-1096.446,736.855-1094.977,739.024-1094.358,740.416Z",
    transform: "translate(1152.964 -710.366)",
    fill: "#ee4823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161577",
    "data-name": "Path 161577",
    d: "M-1181.945,705.422c-.314-.426-.75-.886-1.1-.525a2,2,0,0,0-.291,1.254c-.033,4.465,1.294,8.908,3.5,11.7a19.7,19.7,0,0,1-3.717-6.684,24.367,24.367,0,0,0,1.5,7.376,9.349,9.349,0,0,0-2.555-2.58,2.089,2.089,0,0,0-2.872.668c6.07,7.262,13.61,11.405,21.214,11.653a35.893,35.893,0,0,1-9.691-8.957,42.859,42.859,0,0,0,9.1,6.481,3.849,3.849,0,0,0,3.094.608,3.126,3.126,0,0,0,1.7-3.184c-.207-1.553-1.4-1.833-2.19-2.224a42.092,42.092,0,0,1-6.37-3.907A53.737,53.737,0,0,1-1181.945,705.422Z",
    transform: "translate(1189.491 -696.999)",
    fill: "#d13627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161578",
    "data-name": "Path 161578",
    d: "M-1120.246,726.377c-.925-2.375-2.418-4.323-4.17-4.7s-3.685,1.134-4.253,3.782c-1.338-1-2.793-2-4.256-1.646s-2.829,2.681-2.386,4.925c.368,1.906,1.729,2.744,2.9,3.459,1.46.891,2.732,2.1,4.2,2.9.778.427,3.826,2.278,3.951,3.8a6.705,6.705,0,0,1,1.233-4.637,1.992,1.992,0,0,1,3.183-.28c.759.689,1.337,1.774,1.141-.793A24.748,24.748,0,0,0-1120.246,726.377Z",
    transform: "translate(1167.993 -703.956)",
    fill: "#d13627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161579",
    "data-name": "Path 161579",
    d: "M-1126.9,733.818a5.63,5.63,0,0,0-2.612-2.206c-.278-2.619-1.046-5.221-2.543-6.26,1.9-.354,3.87,1.652,4.571,4.487.121-.944.237-1.881.356-2.817.352-.1.627.5.561,1.064q.821-2.251,1.643-4.51a5.9,5.9,0,0,1,4.32,2.832,13.774,13.774,0,0,1,2.135,6.6,13.649,13.649,0,0,0-1.318-3.464c-.664-1.373-1.634-2.471-2.724-2.58s-2.251.975-2.484,2.66c-.258,1.85.53,4.148-.3,5.5-.352-1.131-.709-2.257-1.059-3.386A12.079,12.079,0,0,0-1126.9,733.818Z",
    transform: "translate(1166.614 -704.762)",
    fill: "#ee4823"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161580",
    "data-name": "Path 161580",
    d: "M-1263.257,622.839s-12.532,1.7-10.661,6.35,71.646,36.588,71.646,36.588l-19.107,25.378s-44.353-23.941-54.989-44.117l.682-18.7S-1275.608,622.839-1263.257,622.839Z",
    transform: "translate(-79.26 -139.407)",
    fill: "#abafb8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87739",
    "data-name": "Group 87739",
    transform: "translate(-1389.91 538.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87738",
    "data-name": "Group 87738",
    transform: "translate(28.253 0)"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161581",
    "data-name": "Path 161581",
    d: "M-1237.635,827.289s.893-.682,2.114,3.454,6.117,32.021,3.717,33.4-7.949-1.416-7.949-1.416-4.773-7.06-4.829-9.011-3.548-8.006-2.455-10.832,2.591-7.8,2.716-7.985,1.4-2.467,1.736-3.222S-1237.635,827.289-1237.635,827.289Z",
    transform: "translate(1270.378 -762.213)",
    fill: "#7b7d8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87737",
    "data-name": "Group 87737",
    transform: "translate(19.287)"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161582",
    "data-name": "Path 161582",
    d: "M-1217.535,829.461s.675-.484,1.5,2.607,3.888,23.867,2.081,24.841-5.864-1.216-5.864-1.216-3.4-5.334-3.4-6.783-2.468-6.01-1.6-8.083,2.079-5.73,2.175-5.862,1.091-1.8,1.354-2.353A30.92,30.92,0,0,1-1217.535,829.461Z",
    transform: "translate(1241.91 -763.115)",
    fill: "#7b7d8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87736",
    "data-name": "Group 87736",
    transform: "translate(10.471)"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161583",
    "data-name": "Path 161583",
    d: "M-1213.242,823.316l-3.96,4.8a123.182,123.182,0,0,1-18.758,2.554q2.273,11.966,4.388,23.962c13.307-2.691,30.012-6.4,33.877-8.811Z",
    transform: "translate(1235.96 -760.591)",
    fill: "#f0ab7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87735",
    "data-name": "Group 87735",
    transform: "translate(12.744)"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161584",
    "data-name": "Path 161584",
    d: "M-1207.673,830.5c4.3,13.321,11.687,20.468,11.687,20.468-3.8-4.105-5.687-20.888-7.853-22.965C-1204.65,828.16-1206.414,830.29-1207.673,830.5Z",
    transform: "translate(1211.54 -762.525)",
    fill: "#e98047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87734",
    "data-name": "Group 87734"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87731",
    "data-name": "Group 87731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161585",
    "data-name": "Path 161585",
    d: "M-1207.256,779.1s-4.044-15.815-1.314-24.028-.281-16.926-1.058-20.564-8.837-18-1.7-18c3.35,0,14.823-.585,14.1,13.4s-2.9,17.43,3.484,17.479,14.183-.738,15.847,12.881",
    transform: "translate(1214.258 -716.503)",
    fill: "#f0ab7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161586",
    "data-name": "Path 161586",
    d: "M-1202.065,737.678s12.238,4.245,8.286-12.42c0,0,4.077,5.9-.389,17.154C-1197.645,751.177-1202.065,737.678-1202.065,737.678Z",
    transform: "translate(1209.225 -720.116)",
    fill: "#e98047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87733",
    "data-name": "Group 87733",
    transform: "translate(6.121 31.766)"
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161587",
    "data-name": "Path 161587",
    d: "M-1200.231,776.773s17.537-9.934,26.157-4.608c0,0,3.023,4.5,3.3,7.869,0,0,6.191,6.618,3.477,12.673,0,0,2.766,8.806-.746,12.415,0,0,1.86,8.268-2.7,13.729,0,0-7.843,5.269-13.466,4.92,0,0-5.39,3.5-9.109,2.79,0,0-9.661-11.62-9.955-30.329C-1203.28,796.231-1205.76,782.661-1200.231,776.773Z",
    transform: "translate(1203.834 -770.595)",
    fill: "#f0ab7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87732",
    "data-name": "Group 87732",
    transform: "translate(11.226 8.723)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161588",
    "data-name": "Path 161588",
    d: "M-1184.167,793.156l-.551-1.318c.6-.263,14.7-6.349,21.824-6.389l.01,1.43C-1169.729,786.924-1184.02,793.095-1184.167,793.156Z",
    transform: "translate(1184.718 -785.45)",
    fill: "#e98047"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161589",
    "data-name": "Path 161589",
    d: "M-1179.241,816.626l-.548-1.318c.709-.31,17.532-7.592,22.311-8.263l.195,1.418C-1161.88,809.108-1179.062,816.551-1179.241,816.626Z",
    transform: "translate(1182.683 -794.363)",
    fill: "#e98047"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161590",
    "data-name": "Path 161590",
    d: "M-1174.9,837.946l-.647-1.269c.6-.314,14.727-7.786,19.07-8.486l.218,1.416C-1160.373,830.277-1174.753,837.871-1174.9,837.946Z",
    transform: "translate(1180.933 -803.092)",
    fill: "#e98047"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161591",
    "data-name": "Path 161591",
    d: "M-1205.667,784.559s1.849-12.121,26.091-13.252C-1179.575,771.308-1205.82,769.821-1205.667,784.559Z",
    transform: "translate(1210.712 -739.106)",
    fill: "#e98047"
  }))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161592",
    "data-name": "Path 161592",
    d: "M-1244.364,867.609a94.975,94.975,0,0,0,18.525-10.681s-9.644-16.459-3.577-27.448a97.033,97.033,0,0,1-24.375,2.942C-1251.017,844.257-1247.991,856.005-1244.364,867.609Z",
    transform: "translate(1253.791 -763.135)",
    fill: "#8f919b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161593",
    "data-name": "Path 161593",
    d: "M-1251.684,841.191a209.722,209.722,0,0,1,21.861-10.9c.129-.272.26-.546.407-.812a97.033,97.033,0,0,1-24.375,2.942Q-1252.761,836.811-1251.684,841.191Z",
    transform: "translate(1253.791 -763.135)",
    fill: "#7b7d8e"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161594",
    "data-name": "Path 161594",
    d: "M-1275.351,878.875c15.092-5.246,18.129-5.879,27.289-14.7,0,0-13.6-21.817-5.831-36.855,0,0-13.379,4.293-32.743,4.889C-1282.459,848.056-1280.663,863.373-1275.351,878.875Z",
    transform: "translate(1286.635 -762.243)",
    fill: "#e2ebf2"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161595",
    "data-name": "Path 161595",
    d: "M-1275.316,827.742s-40.337,8.663-59.431-.5C-1334.747,827.242-1318.486,838.881-1275.316,827.742Z",
    transform: "translate(1334.747 -762.211)",
    fill: "#abafb8"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161596",
    "data-name": "Path 161596",
    d: "M-1082.562,677.745s-3.521,7.412-16.424,13.7l9.168,17.273S-1081.223,688.1-1082.562,677.745Z",
    transform: "translate(-152.475 -162.07)",
    fill: "#abafb8"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "blink",
    transform: "translate(-1303.908 430.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87740",
    "data-name": "Group 87740",
    transform: "translate(1.727 0.338) rotate(14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161597",
    "data-name": "Path 161597",
    d: "M-1188.3,548.657s.714-9.808,5.7-11.448,8.827,2.311,8.827,2.311,3.395,7.224-1.723,8.62C-1181.186,549.692-1184.3,549.161-1188.3,548.657Z",
    transform: "translate(1188.297 -536.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161598",
    "data-name": "Path 161598",
    d: "M-1188.3,548.657s.714-9.808,5.7-11.448,8.827,2.311,8.827,2.311-2.5-2.371-6.766-.82C-1186.081,540.716-1185.323,544.649-1188.3,548.657Z",
    transform: "translate(1188.297 -536.811)",
    fill: "#1b100e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10589",
    "data-name": "Ellipse 10589",
    cx: 2.845,
    cy: 3.297,
    rx: 2.845,
    ry: 3.297,
    transform: "translate(3.802 3.756)",
    fill: "#1b100e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87741",
    "data-name": "Group 87741",
    transform: "translate(22.165 1.359) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161599",
    "data-name": "Path 161599",
    d: "M-1148.7,534.777s-.083.225-.18.583c-.292,1.084-.725,4.017.636,4.99,1.81,1.293,9.32.794,9.32.794s-.905-7.371-5.172-7.758S-1148.7,534.777-1148.7,534.777Z",
    transform: "translate(1149.183 -533.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10590",
    "data-name": "Ellipse 10590",
    cx: 2.069,
    cy: 2.651,
    rx: 2.069,
    ry: 2.651,
    transform: "translate(0.745 1.907)",
    fill: "#1b100e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161600",
    "data-name": "Path 161600",
    d: "M-1148.539,534.777s-.428.857-.18.583c1.552-1.716,3.62-1.521,5.689-.81,2.93,1.007,4.267,6.594,4.267,6.594s-.9-7.371-5.172-7.758S-1148.539,534.777-1148.539,534.777Z",
    transform: "translate(1149.023 -533.33)",
    fill: "#1b100e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/manager.276dc8c65ddf671acbd6f22d2470cb9f.svg";
export { ForwardRef as ReactComponent };